// ======================================================
// Updated by: Halimunnisa
// Feature: Customer Acceptance Workflow
// Purpose: Renders the search and filter controls for the Customer Acceptance tab, mirroring the existing InitialQuotationApprovalControlPanel.
// ======================================================
import React from 'react';
import { FilterSection } from "@/components/ui/FilterSection";

export const CustomerAcceptanceControlPanel = ({ search, setSearch, filters, setFilters, onExport, isExporting }) => {
  const handleSetFilters = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };
//updated by: Halimunnisa
//Customer Acceptance workflow
//Reused InitialQuotationApprovalControlPanel architecture for consistency across approval workflows. The filter controls are aligned with the specific needs of the Customer Acceptance tab, allowing for search and export functionality while maintaining a clean and intuitive UI.
  return (
    <div className="flex flex-col rounded-2xl overflow-hidden bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)] min-w-0 mb-4">
      <FilterSection
        search={search}
        setSearch={setSearch}
        filters={filters}
        setFilters={handleSetFilters}
        isAdvancedFilterInline={true}
        onExport={onExport}
        isExporting={isExporting}
      />
    </div>
  );
};

export default CustomerAcceptanceControlPanel;
